import axios from '../utils/request';
import { IResponse } from '../constants/interface';
import { AxiosRequestConfig } from 'axios';

/** POST 上传 */
function Upload(
  url: string,
  params: FormData,
  otherConfig?: AxiosRequestConfig,
): Promise<IResponse> {
  return axios.post(url, params, otherConfig);
}

export default Upload;
